import { contactContent } from '@/mocks/home';

export default function SectionContact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 mx-auto max-w-7xl">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <p className="text-sm font-medium text-secondary-600 mb-2">沟通桥梁</p>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">{contactContent.title}</h2>
            <p className="text-foreground-500 text-sm mt-3">{contactContent.description}</p>
          </div>

          <div className="bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/60">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
              <div className="text-center">
                <div className="w-11 h-11 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-mail-line text-xl text-primary-600"></i>
                </div>
                <div className="text-xs text-foreground-500 mb-1">电子邮箱</div>
                <div className="text-sm font-medium text-foreground-800">{contactContent.email}</div>
              </div>
              <div className="text-center">
                <div className="w-11 h-11 rounded-xl bg-accent-100 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-wechat-line text-xl text-accent-600"></i>
                </div>
                <div className="text-xs text-foreground-500 mb-1">微信公众号</div>
                <div className="text-sm font-medium text-foreground-800">{contactContent.wechat}</div>
              </div>
              <div className="text-center">
                <div className="w-11 h-11 rounded-xl bg-secondary-100 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-customer-service-2-line text-xl text-secondary-600"></i>
                </div>
                <div className="text-xs text-foreground-500 mb-1">客服 QQ</div>
                <div className="text-sm font-medium text-foreground-800">{contactContent.qq}</div>
              </div>
              <div className="text-center">
                <div className="w-11 h-11 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-time-line text-xl text-primary-600"></i>
                </div>
                <div className="text-xs text-foreground-500 mb-1">服务时间</div>
                <div className="text-sm font-medium text-foreground-800 whitespace-nowrap">{contactContent.hours}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}